import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DataExplorationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"data_exploration"}/>
}
